import { useNavigate } from "react-router-dom";
import MainLayout from "../../../commons/layout/MainLayout";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import Button from "../../../commons/components/Button";
import PhotoSelector from "../../../commons/components/Forms/PhotoSelector";
import Slider from "../../../commons/components/Slider";
import ROUTERS from "../../../commons/constans/router";

type Props = {
  footerShow: Boolean
}

const InformationComponent = ({footerShow}:Props) => {

  const datas = [
    {id: 1, label: '뽀로로'},
    {id: 2, label: '콩순이'},
    {id: 3, label: '카봇'},
    {id: 4, label: '시크릿쥬쥬'},
    {id: 5, label: '또봇'},
    {id: 6, label: '터닝메카드'},
    {id: 7, label: '킨디키즈'},
    {id: 8, label: '메탈리온'},
    {id: 9, label: 'BT21'},
    {id: 10, label: '시크릿쥬쥬'},
    {id: 11, label: '또봇'},
    {id: 12, label: '터닝메카드'},
  ];
  const navigate = useNavigate();
  const handleLeftClick = () => {
    navigate(ROUTERS.HOME);
  }

  const renderSliderItem = (page) => {
    return datas.map((item, key) => (
      <div className="col-4" key={`item_${key + page}`}>
        <div className="item">
          <div className="img">
            <PhotoSelector
              id="js-baby"
              name="input-baby"
              value={`/images/information_${item?.id}.png`}
              path={`/images/information_${item?.id}.png`}
              checked={(page == 1 && (item.id == 5 || item.id == 1)) ? true : false}
            />
          </div>
          <div className="description">
            <span>{item.label}</span>
          </div>
        </div>
      </div>
    ))
  }

  return (
    <MainLayout
      pageClass = {'information-page'}
      footerShow={false}
      headerShow={false}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="맞춤정보"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div className="information">
        <div className="information-title">
          우리 아이가 좋아하는 <br /> 캐릭터를 모두 선택해주세요!
        </div>
        <div className="information-slider">
          <Slider
            pagination={true}
            delay={90000}
            loop={true}
            autoplay={true}
            classSlider="swiper-pagination__custom"
            autoHeight={true}
          >
            <div className="box">
              <div className="row">
                {renderSliderItem (1)}
              </div>
            </div>
            <div className="box">
              <div className="row">
                {renderSliderItem (2)}
              </div>
            </div>
            <div className="box">
              <div className="row">
                {renderSliderItem (3)}
              </div>
            </div>

            <div className="box">
              <div className="row">
                {renderSliderItem (4)}
              </div>
            </div>
          </Slider>
        </div>
        <div className="information-button">
          <Button customClass="btn-custom">저장</Button>
        </div>
      </div>
    </MainLayout>
  )
}

export default InformationComponent;